// extracted by mini-css-extract-plugin
export default {"link":"category-button_link__XDeiC","link_active":"category-button_link_active__LaJc9","none":"category-button_none__8KYjZ"};